import React from 'react';
import { Link } from "react-router-dom";
import useSearchLinkedEntitiesList from "v4/features/front/searchLinkedEntities/hooks/useSearchLinkedEntitiesList";

export default function SearchLinkedEntitiesList({entity, checkedRows}) {
    const {
        isDisabled,
        searchableList
    } = useSearchLinkedEntitiesList(entity, checkedRows);

    return (
        <>
            {searchableList.map((searchableEntity) => (
                <li key={searchableEntity.key} className={`listing-header__action__item ${isDisabled ? 'listing-header__action__item__disabled' : ''}`}>
                    <Link to={searchableEntity.link}>
                        <p>{searchableEntity.searchText}</p>
                    </Link>
                </li>
            ))}
        </>
    )
}
